var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm10":"","offset-sm1":"","md8":"","offset-md2":"","lg6":"","offset-lg3":"","xl4":"","offset-xl4":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }